<template>
  <v-container id="topBrands" fluid class="brand-search">
    <v-row ma-0 pa-0>
      <v-col cols="12" md="3" sm="6">
        <v-btn
          block
          class="btn"
          :class="{ active: filter === 'recent' }"
          rounded
          large
          @click="
            searchType('recent'),
              $analytics('ver-marcas', 'click', 'as_mais_recentes')
          "
        >
          AS MAIS RECENTES
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-btn
          block
          class="btn"
          :class="{ active: filter === 'alphabetical' }"
          rounded
          large
          @click="
            searchType('alphabetical'),
              $analytics('ver-marcas', 'click', 'ordem_alfabetica')
          "
        >
          ORDEM ALFABÉTICA
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <v-btn
          block
          class="btn"
          :class="{ active: filter === 'category' }"
          rounded
          large
          @click="
            searchCategory(), $analytics('ver-marcas', 'click', 'por_categoria')
          "
        >
          POR CATEGORIA
        </v-btn>
      </v-col>
      <v-col cols="12" md="3" sm="6">
        <template>
          <v-btn
            block
            class="btn"
            :class="{ active: filter === 'search' }"
            rounded
            large
            @click="
              searchType('search'),
                $analytics('ver-marcas', 'click', 'pesquisar')
            "
          >
            PESQUISAR
          </v-btn>
        </template>
      </v-col>
    </v-row>
    <v-expand-transition>
      <v-row v-show="filter === 'category'" class="categories">
        <v-chip
          v-for="(category, i) in categories"
          :key="i"
          class="ma-2 chip-font-family"
          :color="color"
          :class="{
            'chip-selected': selectedCategories === category.identifier,
          }"
          :outlined="selectedCategories !== category.identifier"
          @click="categorySelected(category)"
        >
          {{ category.title }}
        </v-chip>
      </v-row>
    </v-expand-transition>
    <v-col
      v-show="filter === 'search'"
      cols="12"
      md="4"
      offset-md="4"
      align="center"
    >
      <v-text-field
        v-model="brandsFilter.qry"
        label="Pesquisar"
        solo
        @keyup="search()"
      />
    </v-col>
    <v-row class="brands">
      <v-col v-for="(brand, i) in brands" :key="i" cols="6" md="2" sm="4">
        <div
          class="brand"
          @click.stop="
            brandSelected = brand;
            dialogBrand = true;
          "
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100%; cursor: pointer"
          >
            <v-img :src="brand.logo_url" class="image-brand" contain />
          </v-row>
        </div>
      </v-col>
      <v-col
        v-for="(box, i) in boxLoadind"
        v-show="loading"
        :key="'bl-' + i"
        cols="6"
        md="2"
        sm="4"
      >
        <v-sheet class="px-3 pt-3 pb-3 brand">
          <v-skeleton-loader
            class="mx-auto"
            max-width="300"
            max-height="100"
            type="card"
          />
        </v-sheet>
      </v-col>
    </v-row>
    <v-row v-show="!loading" justify="center">
      <v-btn
        v-show="brands.length > 12"
        rounded
        large
        class="buttonView"
        @click="viewLess(), $analytics('ver-marcas', 'click', 'ver_menos')"
      >
        VER MENOS
      </v-btn>
      <v-btn
        v-show="brands.length >= 12 && brands.length < totalBrands"
        rounded
        large
        class="buttonView"
        @click="viewMore(), $analytics('ver-marcas', 'click', 'ver_mais')"
      >
        VER MAIS
      </v-btn>
    </v-row>
    <h2 v-show="!brands.length && !loading" class="no-brands">
      Nenhuma marca encontrada
    </h2>
    <v-dialog v-model="dialogBrand" max-width="900">
      <v-card>
        <div class="exit-btn-position">
          <v-btn class="exit-btn px-0" text img @click="dialogBrand = false">
            <v-img
              class="exit-img"
              max-width="32"
              contain
              alt="Fechar"
              :src="require('@/assets/images/materialicons/close.svg')"
            />
          </v-btn>
        </div>
        <highlight-container
          style="padding: 0px"
          fluid
          :title="brandSelected.name"
          even
        >
          <banner-with-button
            :text-button="textTermsButtons"
            :image="brandSelected.logo_url"
            :description="brandSelected.description"
            :href-button="brandSelected.website_url"
            redirect-page
          />
        </highlight-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BrandsProvider from '@/providers/BrandsProvider';

export default {
  name: 'SearchBrands',
  components: {
    HighlightContainer: () => import('@/components/HighlightContainer.vue'),
    BannerWithButton: () => import('@/components/BannerWithButton.vue'),
  },
  data() {
    return {
      brands: [],
      brandSelected: {},
      totalBrands: 0,
      brandsFilter: {},
      categories: [],
      categoriesFilter: {
        top: -1,
        skip: 0,
      },
      filter: 'recent',
      selectedCategories: [],
      searchText: '',
      loading: false,
      boxLoadind: Array(12),
      dialogBrand: false,
      color: '#01ee55',
      textTermsButtons: ['clique e conheca'],
    };
  },
  async mounted() {
    this.setBrandsFilterDefault();

    this.categories = await this.getCategories();
    this.categories.sort((a, b) => {
      if (a.title < b.title) {
        return -1;
      }
      if (a.title > b.title) {
        return 1;
      }
      return 0;
    });
    const outros = this.categories.splice(
      this.categories.findIndex(c => c.title === 'Outros'),
      1,
    );
    this.categories.push(outros[0]);

    const brands = await this.searchBrands()[this.brandsFilter.orderby]();
    this.brands = brands.brands;
    this.totalBrands = brands.total;

    this.checkClass();
  },
  methods: {
    setBrandsFilterDefault() {
      this.brandsFilter = {
        top: 12,
        skip: 0,
        orderby: 'recent',
        qry: '',
        shallow: 0,
        tag: '',
      };
    },
    async getCategories() {
      const categories = await BrandsProvider.getBrandCategories(
        this.categoriesFilter,
      );
      return categories.data.data;
    },
    async getBrands() {
      this.loading = true;
      const brands = await BrandsProvider.getBrandList(this.brandsFilter);
      this.loading = false;
      return brands.data;
    },
    async viewMore() {
      this.brandsFilter.skip += 12;

      const moreBrands = await this.getBrands();
      this.brands = this.brands.concat(moreBrands.data);
      this.totalBrands = moreBrands.total;
    },
    viewLess() {
      this.brands = this.brands.slice(0, 12);
      this.brandsFilter.skip = 0;
      document.getElementById('topBrands').scrollIntoView();
    },
    async searchType(type) {
      if (this.filter !== type) {
        this.brands = [];
        this.filter = type;
        this.setBrandsFilterDefault();
        this.brandsFilter.orderby =
          type === 'alphabetical' ? 'alphabetical' : 'recent';

        const brands = await this.searchBrands()[this.brandsFilter.orderby]();
        this.brands = brands.brands;
        this.totalBrands = brands.total;
      }
    },
    searchCategory() {
      if (this.filter !== 'category') {
        this.filter = 'category';
        this.selectedCategories = '';
        this.setBrandsFilterDefault();
      }
    },
    async categorySelected(category) {
      if (this.selectedCategories !== category.identifier) {
        this.brands = [];
        this.selectedCategories = category.identifier;
        this.brandsFilter.tag = category.identifier;

        const brands = await this.getBrands();
        this.brands = brands.data;
        this.totalBrands = brands.total;
      }
    },
    async search() {
      this.brands = [];

      const brands = await this.getBrands();
      this.brands = brands.data;
      this.totalBrands = brands.total;
    },
    searchBrands() {
      return {
        recent: async () => {
          if (this.$store.state.brands.recent.brands.length) {
            return this.$store.state.brands.recent;
          }
          const brands = await this.getBrands();
          this.updateRecentBrands(brands);
          return this.$store.state.brands.recent;
        },
        alphabetical: async () => {
          if (this.$store.state.brands.alphabetical.brands.length) {
            return this.$store.state.brands.alphabetical;
          }
          const brands = await this.getBrands();
          this.updateAlphabeticalBrands(brands);
          return this.$store.state.brands.alphabetical;
        },
      };
    },
    updateRecentBrands(brands) {
      this.$store.commit('brands/updateRecentBrands', brands);
    },
    updateAlphabeticalBrands(brands) {
      this.$store.commit('brands/updateAlphabeticalBrands', brands);
    },
    checkClass() {
      if (document.querySelector('.new-color')) {
        this.color = '#26d07c';
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.btn
  background-color: lightgrey !important
  white-space: normal
.btn.active
  background-color: $primary !important
  color: #fff !important

.brands
  padding: 0
  height: auto
  overflow: visible

  .brand
    height: 120px
    border-radius: 20px
    background-color: white
    font-family: 'Proxima Nova', sans-serif
    @media screen and (max-width: $sm)
      height: 120px
    @media screen and (max-width: $xs)
      height: 130px
    &:hover
      background-color: #01ee55
      transition: ease all 1.5s
    & span
      font-family: 'Proxima Nova', sans-serif !important
      font-weight: 600
      font-size: 1.2em
      @media screen and (max-width: $sm)
        font-size: 20px

  .image-brand
    max-height: 80%
    max-width: 80%

.categories
  padding: 0 10px 0 10px

.hidden
  height: 3 * 100px
  overflow: hidden

.buttonView
  margin: 10px
  width: 20%
  @media screen and (max-width: $sm)
    width: 45%
  @media screen and (max-width: $xs)
    width: 100%

.exit-btn
  min-width: 36px !important
  background-color: transparent !important
  .exit-img
    fill: #999

.exit-btn-position
  display: flex
  justify-content: flex-end

.chip-font-family
  font-family: "Proxima Nova", sans-serif !important
  font-size: 1em !important

.chip-selected
  color: #fff !important

.no-brands
  font-weight: normal
  font-family: "Proxima Nova", sans-serif !important
  text-align: center
  margin: 20px 0

.new-color
  .btn.active
    background-color: $secondary !important
  .brands
    .brand
      font-family: 'metropolisregular', sans-serif
      &:hover
        background-color: #26d07c
      & span
        font-family: 'metropolisregular', sans-serif !important
  .chip-font-family,
  .no-brands
    font-family: 'metropolisregular', sans-serif !important
</style>
